module.exports = {"TXTWCL_Place_Bet":{"id":"TXTWCL_Place_Bet","defaultMessage":"Wette platzieren","track":"Place Bet"}}